import styled from "styled-components";

export const TrackBar = styled.div`
  position: absolute;
  transform: translate(0%, -50%);
  height: ${({ theme }) => theme.filters.height.lg};
  z-index: 1;
  background-color: ${({ $disabled, theme }) =>
    $disabled ? theme.grey2 : theme.highlight};
  border-radius: 12px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  left: ${({ $leftPercent }) => `${$leftPercent}%`};
  width: ${({ $widthPercent }) => `${$widthPercent}%`};
`;
